var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardlogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0664062,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E6F8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.468194,
    y: 0.401787,
    width: 43.1964,
    height: 43.1964,
    rx: 21.5982,
    stroke: "#09B81D",
    strokeOpacity: 0.1,
    strokeWidth: 0.803575
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1063 31.1204C23.1133 31.1204 21.3399 30.5546 19.7861 29.423C18.2322 28.2914 17.1344 26.8304 16.4926 25.0401H12.9458V23.0134H16.0366C15.9859 22.608 15.965 22.2324 15.9738 21.8865C15.9825 21.5406 16.0035 21.2407 16.0366 20.9866H12.9458V18.9599H16.4926C17.1344 17.1696 18.2322 15.7086 19.7861 14.577C21.3399 13.4454 23.1133 12.8796 25.1063 12.8796C26.2717 12.8796 27.3739 13.0867 28.413 13.5008C29.452 13.915 30.3765 14.4848 31.1866 15.2104L29.7425 16.6291C29.1176 16.0887 28.4126 15.6664 27.6276 15.3624C26.8426 15.0584 26.0021 14.9064 25.1063 14.9064C23.6707 14.9064 22.3871 15.2824 21.2555 16.0343C20.1239 16.7862 19.271 17.7614 18.6967 18.9599H25.1063V20.9866H18.0887C18.0211 21.4427 17.9958 21.844 18.0127 22.1905C18.0296 22.5371 18.0549 22.8114 18.0887 23.0134H25.1063V25.0401H18.6967C19.271 26.2393 20.1239 27.2149 21.2555 27.9668C22.3871 28.7187 23.6707 29.0943 25.1063 29.0936C26.0015 29.0936 26.8419 28.9416 27.6276 28.6376C28.4133 28.3336 29.1183 27.9114 29.7425 27.3709L31.1866 28.7896C30.3759 29.5159 29.451 30.0861 28.4119 30.5002C27.3729 30.9143 26.271 31.1211 25.1063 31.1204Z",
    fill: "#09B81D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardlogo2);
export default __webpack_public_path__ + "static/media/dashboardlogo2.531ba3591295bc031cb31250cccf66ea.svg";
export { ForwardRef as ReactComponent };